import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AppKitAuthContext";
import styles from "../styles/WelcomeAirdropNotification.module.css";

interface WelcomeAirdropNotificationProps {
  hasActiveGame?: boolean;
}

const WelcomeAirdropNotification: React.FC<WelcomeAirdropNotificationProps> = ({ hasActiveGame = false }) => {
  // const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const { isAuthenticated, userInfo } = useAuth();

  const isAuthenticatedRef = useRef(isAuthenticated);
  useEffect(() => {
    // Reset dismissed state when user signs in (auth changes from false to true)
    if (!isAuthenticatedRef.current && isAuthenticated) {
      setIsDismissed(false);
    }
    isAuthenticatedRef.current = isAuthenticated;
  }, [isAuthenticated]);

  // Show notification if user is eligible but hasn't participated and hasn't dismissed
  useEffect(() => {
    if (
      isAuthenticated && 
      userInfo?.welcomeAirdropEligible && 
      !userInfo?.welcomeAirdropParticipated &&
      !isDismissed
    ) {
      setShowNotification(true);

      // Hide notification after 20 seconds
      const timer = setTimeout(() => setShowNotification(false), 20000);
      return () => clearTimeout(timer);
    } else {
      setShowNotification(false);
    }
  }, [userInfo, isAuthenticated, isDismissed]);

  const handleClick = () => {
    // navigate("/events/welcome-airdrop");
    // use telegram airdrop bot now
    window.open("https://t.me/DeathXFunAirdropBot", '_blank', 'noopener,noreferrer')
  };

  const handleClose = () => {
    setShowNotification(false);
    setIsDismissed(true);
  };

  // Hide if there's an active game or if conditions aren't met
  if (hasActiveGame || !showNotification) {
    return null;
  }

  return (
    <div className={styles.airdropNotification}>
      <div className={styles.notificationContent}>
        <div className={styles.notificationIcon}>🎁</div>
        <div className={styles.notificationText}>
          <div className={styles.notificationTitle}>Welcome Airdrop Available!</div>
          <div className={styles.notificationSubtitle}>
            You are eligible for a welcome airdrop of $DXF tokens.{" "}
            <span onClick={handleClick} className={styles.clickableText}>
              Claim your tokens now!
            </span>
          </div>
        </div>
        <button className={styles.notificationClose} onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default WelcomeAirdropNotification;